__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "clientapp";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@j-t-mcc/vue3-chartjs", "1.3.0", function() { return __webpack_require__.e(681).then(function() { return function() { return __webpack_require__(4062); }; }); });
			register("@microsoft/signalr", "6.0.25", function() { return __webpack_require__.e(233).then(function() { return function() { return __webpack_require__(233); }; }); });
			register("@popperjs/core", "2.11.8", function() { return __webpack_require__.e(216).then(function() { return function() { return __webpack_require__(1216); }; }); });
			register("bootstrap", "5.3.3", function() { return __webpack_require__.e(747).then(function() { return function() { return __webpack_require__(8747); }; }); });
			register("chart.js", "3.9.1", function() { return __webpack_require__.e(237).then(function() { return function() { return __webpack_require__(7237); }; }); });
			register("chartjs-plugin-annotation", "2.2.1", function() { return __webpack_require__.e(891).then(function() { return function() { return __webpack_require__(1891); }; }); });
			register("chartjs-plugin-zoom", "1.2.1", function() { return __webpack_require__.e(839).then(function() { return function() { return __webpack_require__(3839); }; }); });
			register("date-fns", "2.30.0", function() { return __webpack_require__.e(151).then(function() { return function() { return __webpack_require__(3151); }; }); });
			register("diacriticless", "1.0.1", function() { return __webpack_require__.e(239).then(function() { return function() { return __webpack_require__(239); }; }); });
			register("lodash.isequal", "4.5.0", function() { return __webpack_require__.e(142).then(function() { return function() { return __webpack_require__(8142); }; }); });
			register("lodash.merge", "4.6.2", function() { return __webpack_require__.e(182).then(function() { return function() { return __webpack_require__(182); }; }); });
			register("vue-router", "4.4.0", function() { return __webpack_require__.e(458).then(function() { return function() { return __webpack_require__(5220); }; }); });
			register("vue", "3.4.34", function() { return __webpack_require__.e(726).then(function() { return function() { return __webpack_require__(9726); }; }); });
			register("vuex", "4.1.0", function() { return __webpack_require__.e(897).then(function() { return function() { return __webpack_require__(6278); }; }); });
			initExternal(9925);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};